import { Typography } from '@navi/web-ui/lib/primitives';
import { FontType } from '@navi/web-ui/lib/primitives/Typography/types';

interface IHeaderProps {
  title: string;
  variant?: FontType;
}
const LeftHeader = (props: IHeaderProps) => {
  const { title, variant = 'h3' } = props;
  return (
    <Typography variant={variant} color="var(--grayscale-2)">
      {title}
    </Typography>
  );
};

export default LeftHeader;
